/**
 * Generic CRUD operation actions
 *
 * These actions provide a generic way to load and manipulate data inside Selfpoint.
 *
 */

import {
  LOAD_DATASET_V3,
  LOAD_DATASET_V3_SUCCESS,
  UNLOAD_DATASET_V3,
  SUBSCRIBE3,
  // UNSUBSCRIBE3,
  PUB3,
  INIT_UPLOADv3,
  STREAM_UPLOADv3,
  STREAM_UPLOAD_v3_SUCCESS,
  FINISH_UPLOADv3,
  REMOVE_UPLOADv3,
  REMOVE_UPLOAD_v3_SUCCESS,
  INIT_UPLOADv3_SUCCESS,
  PUB3_CONFIRM,
  PUB3_CLEAR,
  DOWNLOAD3,
} from "../constants";

/**
 * @desc load dataset v3
 *
 * @param {string} pageType - one of form, viewInternal or viewExternal.
 * @param {objectId} [componentId] - The id of componet to fetch. Use this if we do not have an anonymous dataset.
 * @param {string} datasetId - The key for this.props.dataset[]. Identifies the dataset.
 * @param {json} [props] - props for the dataset
 * @param {json} [store] - global component state - from redux. Used to pass props from forms/views to dataset
 * @param {string} [source] - Name of database. The name 'source' is historical
 * @param {bool} [anonymous] - Anonymous access. Use this to bypass all page security and query directly an anonymous dataset. Dataset must support anonymous
 *
 * @return {json} - redux
 *
 */
export const loadDatasetv3 = ({
  pageType,
  pageId,
  context,
  componentId,
  source,
  datasetId,
}) => {
  return {
    type: LOAD_DATASET_V3,
    pageId,
    componentId,
    context,
    pageType,
    source,
    datasetId,
  };
};

/**
 * @desc loads a dataset SUCCESS.
 *
 * @param data - loaded data
 * @param _id - _id of component
 * @return {json} - redux
 *
 */
export const loadDatasetv3Success = ({ data, datasetId }) => {
  return {
    type: LOAD_DATASET_V3_SUCCESS,
    data,
    datasetId,
  };
};

/**
 * @desc Unloads a dataset from reducer
 *
 * @param data - loaded data
 * @param _id - _id of component
 * @return {json} - redux
 *
 */
export const unloadDatasetv3 = ({ datasetId }) => {
  return {
    type: UNLOAD_DATASET_V3,
    datasetId,
  };
};

export const subscribe3 = ({ channel }) => {
  return {
    type: SUBSCRIBE3,
    channel,
  };
};

// export const unsubscribe3 = ({ channel }) => {
//   return {
//     type: UNSUBSCRIBE3,
//     channel
//   };
// };

export const pub3 = ({ channel, msg, id }) => {
  return {
    type: PUB3,
    channel,
    msg,
    id,
  };
};

export const confirmPubSub3 = ({ id, channel }) => {
  return {
    type: PUB3_CONFIRM,
    id,
    channel,
  };
};

export const clearPubSub3 = ({ channel }) => {
  return {
    type: PUB3_CLEAR,
    channel,
  };
};

/**
 * @desc Let server know that we intent to upload a file
 *
 */
export const initUpload3 = ({
  assetId,
  name,
  size,
  originalName,
  estimatedChunks,
  mimeType,
  formDataId,
}) => {
  return {
    type: INIT_UPLOADv3,
    assetId,
    name,
    originalName,
    size,
    estimatedChunks,
    mimeType,
    formDataId,
  };
};

export const initUpload3Success = ({
  assetId,
  name,
  size,
  estimatedChunks,
  mimeType,
  formDataId,
}) => {
  return {
    type: INIT_UPLOADv3_SUCCESS,
    assetId,
    name,
    size,
    estimatedChunks,
    mimeType,
    formDataId,
  };
};

/**
 * @desc Send data chunk to server
 *
 */
export const streamUpload3 = ({ assetId, chunkId, data }) => {
  return {
    type: STREAM_UPLOADv3,
    assetId,
    data,
    chunkId,
  };
};

/**
 * @desc Send data chunk to server
 *
 */
export const streamUpload3Success = ({ assetId, chunkId }) => {
  return {
    type: STREAM_UPLOAD_v3_SUCCESS,
    assetId,
    chunkId,
  };
};

export const removeUploadv3 = ({ assetId }) => {
  return {
    type: REMOVE_UPLOADv3,
    assetId,
  };
};

export const removeUpload3Success = ({ assetId }) => {
  return {
    type: REMOVE_UPLOAD_v3_SUCCESS,
    assetId,
  };
};

export const finishUpload3 = ({ assetId }) => {
  return {
    type: FINISH_UPLOADv3,
    assetId,
  };
};

export const download3 = ({ id, page, pageId, onlyURL, preview }) => {
  return {
    type: DOWNLOAD3,
    id,
    page,
    pageId,
    onlyURL,
    preview,
  };
};
